export const TRIGGER_LOCATIONS = {
    PURCHASE_FUNNEL: 'purchase_funnel',
    REFINANCE_FUNNEL: 'refinance_funnel',
    HOMEPAGE: 'homepage',
} as const;

export const TRIGGER_TYPES = {
    INTERACTION: 'interaction',
} as const;

export const TRIGGER_OBJECTS = {
    FOOTER: 'footer',
} as const;

export const TRIGGER_SOURCES = {
    CALL_GENERAL: 'call_general',
} as const;

export const TOPIC_TAG_ARRS = {
    ZHL: ['zhl'],
    ZHL_PURCHASE: ['zhl', 'purchase'],
    ZHL_REFINANCE: ['zhl', 'refinance'],
} as const;

export const SEMANTIC_EVENTS = {
    CALL: 'call',
} as const;
